export default __webpack_public_path__ + "static/pool-1228999_1280-7efe1739818451e12296baa579abe1aa.png";